import { REACT_COMP_VERSION } from '../constants.js';

var addScriptsToDocument = function addScriptsToDocument(scripts) {
  scripts.forEach(function (scriptObj) {
    var scriptElement = document.createElement("script");
    if (scriptObj.src) scriptElement.src = scriptObj.src;
    if (scriptObj.innerHTML) scriptElement.innerHTML = scriptObj.innerHTML;
    document.body.appendChild(scriptElement);
  });
};

var getHeaderKey = function getHeaderKey(tenant, locale, headerType, hideSearch, hideVat) {
  return "".concat(REACT_COMP_VERSION, "_").concat(tenant, "_").concat(locale, "_header_").concat(headerType, "_hidesearch-").concat(hideSearch || false, "_hideVat-").concat(hideVat || false).toLowerCase();
};

var getFooterKey = function getFooterKey(tenant, locale, footerType) {
  return "".concat(REACT_COMP_VERSION, "_").concat(tenant, "_").concat(locale, "_footer_").concat(footerType).toLowerCase();
};

export { addScriptsToDocument, getFooterKey, getHeaderKey };